export default "__VITE_PUBLIC_ASSET__e0d31d58__"